export default __webpack_public_path__ + "static/media/circle-x-overlay.b472db17.svg";